import type { FC } from "react";

import classNames from "classnames";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";

import styles from "./CategoryFilterItem.module.scss";

export type CategoryFilterItemProps = {
  categoryKey: string;
  iconUrl: string;
  label: string;
  isActiveFilter?: boolean;
  onFilterClick: (key: string) => void;
};

export const CategoryFilterItem: FC<CategoryFilterItemProps> = ({
  categoryKey,
  iconUrl,
  label,
  isActiveFilter,
  onFilterClick,
}) => {
  const handleSetActiveFilter = () => {
    onFilterClick(categoryKey);
  };

  return (
    <li className={styles.wrapper} onClick={handleSetActiveFilter}>
      <div
        data-testid="categoryFilterItem"
        className={classNames(styles.item, {
          [styles.active]: isActiveFilter,
        })}
      >
        <div
          data-testid="activeFilterIcon"
          className={classNames(styles.iconWrapper, { [styles.iconWrapperActive]: isActiveFilter })}
        >
          {isActiveFilter && <UiCheckIcon className={styles.checkMark} width="10px" />}
        </div>
        <ImageBehaviour draggable={false} className={styles.image} alt={""} src={iconUrl} />
      </div>
      <p className={styles.label}>{label}</p>
    </li>
  );
};
